export default function User({ className }: { className: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 0.166687L11 5.50002H9V11H5V5.50002H3L7 0.166687Z" fill="currentColor" />
      <path d="M0 12V14H14V12H0Z" fill="currentColor" />
    </svg>
  )
}
